<script>
  import * as _ from "lodash";
  import ProductLineListRow from "./ProductLineListRow.svelte";
  export let list;
  export let results;
  export let onChooseSize;
  export let onAddToListChooseSizeLater;
  export let onRemoveProductLinePlaceholder;

  $: lookup = function (productLine) {
    return (
      list.quick_order_list_products.find(
        qolp => _.get(qolp, "product_line_placeholder.product_line.id") === productLine.id,
      ) || {}
    ).id;
  };

  $: {
    list = list;
  }
</script>

<ul class="product-line-search__result-product-list padding-bottom--2">
  {#each results as row}
    <li key={row.product_line.id}>
      <ProductLineListRow
        result={row}
        quickOrderListProductID={lookup(row.product_line)}
        {onChooseSize}
        {onAddToListChooseSizeLater}
        {onRemoveProductLinePlaceholder}
      />
    </li>
  {/each}
</ul>
